import React from 'react';
import Select from 'react-select';

const wimin = [
  { value: true, label: 'Yes'},
  { value: false, label: 'No'}
];

class WiminSelect extends React.Component {
  render () {
    const {value, onChange, errors} = this.props;
    return (

        <div className="col s12">
          <Select
            options={wimin}
            placeholder='WiminSelect'
            value={value}
            onChange={onChange}
            multi={true}
          />
          <div style={{ color: 'red', fontSize: '0.875rem' }}>
            {(errors || []).join('. ')}
          </div>
        </div>
    )
  }
}

export default WiminSelect;



// WEBPACK FOOTER //
// ./src/containers/Input/WiMINSelect.jsx